export default {
    translation: {
        actions: 'Actions',
        angle: 'Angle',
        appName: 'Golanix',
        backgroundColor: 'Background Color',
        backToHomepage: 'Back to adventure',
        blockProperties: 'Block Properties',
        blueTooth: 'BlueTooth',
        checkAnswer: 'Check answer',
        checkEmailBox: 'Check your email box.',
        color: 'Color',
        communication: 'Communication',
        confirmPassword: 'Confirm password',
        connect: 'Connect',
        connected: 'Connected',
        correctlyAnswer: 'Correctly answer',
        courseImage: 'Course image',
        courses: 'Courses',
        description: 'Description',
        devicesList: 'Devices List',
        direction: 'Direction',
        disconnect: 'Disconnect',
        downloadToRobot: 'Download To Robot',
        doYouWantSave: 'Do you want to save your project before creating a new one?',
        email: 'Email',
        emailAlreadyExists: 'Email already exists',
        emailHasBeenSent: 'Email has been sent!',
        emailHasNotBeenSent: 'Email has not been sent!',
        en: 'English',
        zh: 'Chinese',
        error: 'Error',
        files: 'Files',
        finished: 'Finished',
        finishTopic: 'Finish topic',
        forgotPassword: 'Forgot password?',
        he: 'עברית',
        help: 'Help',
        home: 'Home',
        homepage: 'Homepage',
        id: 'Id',
        image: 'Image',
        language: 'Language',
        languageDoYouWantSave: 'Changing the language will clear your project. Do you want to save firstly?',
        lessons: 'Lessons',
        lesson_image: 'Lesson image',
        level: 'Level',
        level1: 'Beginner',
        level2: 'Novice',
        level3: 'Advanced',
        level4: 'Professional',
        level5: 'Expert',
        list: 'List',
        login: 'Login',
        logout: 'Logout',
        name: 'Name',
        no: 'No',
        notFoundText: 'We couldn`t find the page you`re looking for.',
        notFoundTitle: '404 Page not found',
        notStarted: 'Not started',
        numberOfDaysBeforeLesson: 'Number of days before opening lesson',
        online: 'Online',
        openOurSite: 'Open Our Site',
        password: 'Password',
        passwordHasBeenChanged: 'Password has been changed',
        port: 'Port',
        prerequisiteCourses: 'Prerequisite courses',
        profile: 'Profile',
        register: 'Register',
        resetFilters: 'Reset filters',
        resetPassword: 'Reset password',
        saveResult: 'Save result',
        scanDevices: 'Scan Devices',
        search: 'Search',
        searchFor: 'Search for',
        sendPasswordResetLink: 'Send Password Reset Link',
        settings: 'Settings',
        siteMessage: 'Messages',
        sound: 'Sound',
        sourceCode: 'Source Code',
        speed: 'Speed',
        started: 'Started',
        status: 'Status',
        success: 'Success',
        terminal: 'Terminal',
        topic: 'Topic',
        topicContent: 'Topic Content',
        topicImage: 'Topic image',
        topicQuizzes: 'Topic quizzes',
        topics: 'Topics',
        topicVideo: 'Topic Video',
        tryAgain: 'Try again.',
        updateSystem: 'Update CPU Operation System',
        usb: 'USB',
        userNotExistCredentials: 'The specified user does not exist.',
        workspace: 'Workspace',
        yes: 'Yes',
        youDidNotPassTheQuizzes: 'You did\'t pass the quizzes',
        youSpentLittleTimeWatchingContent: 'You need to spend more time on this chapter',
        version: 'Version',
        //MainPage
        mainPageTitleOnlineRobotic: 'Online Robotic adventures for',
        mainPageTitleAdventurersKids: 'Adventurers Kids',
        mainPageButtonCoursesList: 'Adventures List',
        mainPageButtonSignInUp: 'Sign in | Sign up',
        mainPageContentTitle: 'Our Adventures',
        buttonStartAdventure: 'Start the adventure',
        paginationShowMore: 'Show More',
        programMyRobot: 'PROGRAM MY ROBOT',
        //Pop-up
        notification: 'notification',
        newBadge: 'New Badge',
        youReceivedANewBadge: 'You Received a New Badge',
        newCertificate: 'New Certificate',
        youReceivedANewCertificate: 'You Received a New Certificate',
        selectPicture: 'Select Picture',
        apply: 'Apply',
        uploadPicture: 'Upload Picture',
        signIn: 'Sign In',
        signUn: 'Sign Un',
        forgotMyPassword: 'Forgot My Password',
        doNotHaveAccount: "Don`t have an account?",
        myProfile: 'my profile',
        about: 'about',
        back: 'Back',
        signOut: 'sign out',
        passwordRecovery: 'Password Recovery',
        passwordReset: 'password reset',
        userName: 'User Name',
        yourEmail: 'Your Email',
        signUp: 'Sign Up',
        noInternet: 'No Internet',
        connectToInternet: 'Connect to Internet',
        passwordConfirmation: 'Password confirmation',

        //lessonsPage
        btnContinue: 'continue',
        whatWillLearn: 'What will I Learn ?',
        join: 'Join',
        hours: 'Hours',
        graduated: 'Graduated',
        video: 'Video',
        developingSkills: 'Developing Skills',
        courseBadges: 'Adventure Badges',
        moreAdventurersCourses: 'More Adventures for you',
        learnMoreRobots: 'Learn to Move a Robots',
        news: 'News',
        //dashboard
        activeCourses: 'Active Adventures',
        courseCompleted: 'Adventures Completed',
        lessonsCompleted: 'Chapters Completed',
        skillsAcquired: 'Skills Acquired',
        badges: 'Badges',
        certificates: 'Certificates',
        moreAdventurersForYou: 'More Adventures For You',
        //topic
        filesAndTools: 'Files and Tools',
        yourMission: 'Your Mission',
        quiz: 'Quiz',
        launchProgram: 'Program Robot',
        complete: 'complete',
        sendAnswers: 'send answers',
        wrongQuizAnswer: 'YOU HAVE INCORRECT ANSWERS, TRY AGAIN...',
        correctQuizAnswer: 'WELL DONE!',
        quizPassed: 'QUIZ COMPLETED',
        welcome: 'welcome',
        guest: 'guest',
        willBeAvailable: 'Will Be Available',
        willBeAvailableIn: 'Will Be Available in',
        days: 'days',
        unlockLevel: 'UNLOCK LEVEL',
        pleaseInsertThePassword: 'Please Insert the Password',
        submit: 'Submit',
        close: 'Close',
        invalidPassword: 'Your password is invalid. Please try again!',
        robokidsAndventures: 'Robokids Andventures',
        studentDashboard: 'User Dashboard',
        inTheLessonThereAreNoTopics: 'in the lesson there are no topics',
        courseMapTitle: 'Adventure MAP',
        iWantProgram: 'I want to program my robot',
        afterPreviousLessonCompletion: 'After completing previous chapter',
        rotateYourDevice: 'Please rotate your device.',
        downloading: 'Downloading',
        errorDownloading: 'Error Downloading',
        scanningForRobots: 'Scanning for robots',
        joyStick: 'JoyStick',
        pleaseAnswerTheQuizQuestions: 'Please answer all quiz questions',
        mainPageDescription: 'Robokids offers an adventure combined with learning. Join our adventures and discover the fascinating world of Engineering and Coding.',
        joystickNippleSettings: 'Joystick nipple setup',
        joystickLeftNipple: 'Left',
        joystickRightNipple: 'Right',
        projectDoYouWantSave: 'This action will clear your project. Do you want to save firstly?',
    },
};



// WEBPACK FOOTER //
// ./src/lang/en/en.js